// import Header from "../Header";
// import { ManagerSidebarMenu } from "../sidebar/ManagerSidebarMenu";
// import { ManagerName } from "../../atoms/ManagerName";
//
//
// const ManagerHeader= () => {
//   return <Header name={<ManagerName/>} sideBarMenu={<ManagerSidebarMenu/>}/>
// };
// export default ManagerHeader;

import React from "react";
import ResponsiveHeader from "./ResponsiveHeader";
import { ManagerSidebarMenu } from "../sidebar/ManagerSidebarMenu";
import { ManagerName } from "../../atoms/ManagerName";
import { LogoutModal } from "../LogoutModal";

const ManagerHeader = () => {
  return (
      <ResponsiveHeader
          name={null}
          title="BLOCKs"
          navItems={[<LogoutModal key="logout" />]}
          sidebar={<ManagerSidebarMenu />}
      />
  );
};

export default ManagerHeader;